import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledInvocationFrame = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 16px 22px;
    margin-bottom: 36px;
    background: var(--color-white);
    border: 1px solid var(--color-primary);
    border-radius: var(--radius-10);
    @media ${breakpoints.xs} {
        display: none;
    }
    .companyImage img {
        max-width: 71px;
        max-height: 71px;
    }
    .description {
        flex: 1;
        padding: 0 22px;
        font-size: var(--size-16);
        line-height: 24px;
        color: var(--color-grey-900);
    }
`;

export const StyledLinkButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
